"use client";

import { useTrialForm } from "@/components/providers/TrialFormProvider";

interface TrialButtonProps {
  className?: string;
  children?: React.ReactNode;
}

/**
 * Drop-in button that opens the trial form modal.
 * Use anywhere — the provider handles the rest.
 */
export default function TrialButton({ className, children }: TrialButtonProps) {
  const { openTrialForm } = useTrialForm();

  return (
    <button type="button" onClick={openTrialForm} className={className}>
      {children || "Start Free Trial"}
    </button>
  );
}
